import { Form, Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";

// component
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import InputField from "../../components/form/InputField";

// image
import appLogo from "../../assets/logo/white-logo.png";
import appLogo1 from "../../assets/logo/blue-logo.png";

// css
import "./Signin.css";

// apis
import studentApi from "../../api/Student";

// utilities
import { empty, errorResponse, isUndefined, prepareResponseData } from "../../Utilities/utils";
import { Toast } from "primereact/toast";
import { useRef } from "react";

const initialValues = {
  password: "",
  regNo: "",
};

const validationSchema = Yup.object().shape({
  password: Yup.string().required("Password is required"),
  regNo: Yup.string().required("Registration Number is required"),
});

function Signin() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  //ref
  const toastTR = useRef(null);

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  const handleSubmit = async (values) => {
    try {
      if (!isLoading) setIsLoading(true);
      const regNo =
        !isUndefined(values) && !isUndefined(values.regNo) ? values.regNo : "";
      const password =
        !isUndefined(values) && !isUndefined(values.password)
          ? values.password
          : "";

      const response = await studentApi.studentSignin(regNo, password);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response = !empty(response_data.response)
          ? response_data.response
          : "Something went wrong!";
        return responseDialog("error", "Error Alert!", error_response);
      }

      navigate("/dashboard");
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signInBox">
      <div className="signInLogo">
        <img style={{ width: 80, height: "auto" }} src={appLogo1} alt=""/>
        <span style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
          Anciemdemia
        </span>
        <span>A School Management System</span>
      </div>
      <aside className="leftSide">
        <div className="formBox">
          <div className="welcome">
            <p className="sectionTitle">
              <strong>STUDENT LOGIN</strong>
            </p>
            <span>Hi, Welcome Back</span>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form style={{ width: "100%" }}>
              <InputField
                placeholder="Registration Number"
                name="regNo"
                type="regNo"
                icon="envelope"
              />
              <InputField
                placeholder="Password"
                name="password"
                type="password"
                icon="key"
              />
              <ButtonIcon
                height={45}
                marginTop={5}
                color="#ffffff"
                backgroundColor="#633ccd"
                width="100%"
                borderColor="#633ccd"
                buttonText={
                  isLoading ? (
                    <ProgressSpinner
                      style={{ width: 25, height: 25 }}
                      strokeWidth={7}
                      animationDuration={0.5}
                    />
                  ) : (
                    "Sign In"
                  )
                }
                type="submit"
              />
            </Form>
          </Formik>
        </div>
      </aside>
      <aside className="rightSide">
        <img style={{ width: "10rem", height: "auto" }} src={appLogo} alt="" />
        <span style={{ fontSize: "1.8rem", fontWeight: "bold" }}>
          Anciemdemia
        </span>
        <span>A School Management System</span>
      </aside>
      <Toast ref={toastTR} position="bottom-left" />
    </div>
  );
}

export default Signin;
